import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function SugarSgptForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    fastingSugar: "",
    postMealSugar: "",
    randomSugar: "",
    sgpt: "",
    sgot: "",

    chikIgG: "",
    chikIgM: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>BIOCHEMISTRY + SEROLOGY FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">BIOCHEMISTRY</h5>
        <div className="mb-2">
          <label>Fasting Blood Sugar (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="fastingSugar"
            value={form.fastingSugar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Post Meal Blood Sugar (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="postMealSugar"
            value={form.postMealSugar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>Random Blood Sugar (mg/dl):</label>
          <input
            type="text"
            className="form-control"
            name="randomSugar"
            value={form.randomSugar}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>SGPT (ALT) (u/l):</label>
          <input
            type="text"
            className="form-control"
            name="sgpt"
            value={form.sgpt}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>SGOT (AST) (u/l):</label>
          <input
            type="text"
            className="form-control"
            name="sgot"
            value={form.sgot}
            onChange={handleChange}
          />
        </div>

        <h5 className="mt-4">SEROLOGY - CHIKUNGUNYA</h5>

        <div className="mb-2">
          <label>IgG:</label>
          <input
            type="text"
            className="form-control"
            name="chikIgG"
            value={form.chikIgG}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>IgM:</label>
          <input
            type="text"
            className="form-control"
            name="chikIgM"
            value={form.chikIgM}
            onChange={handleChange}
          />
        </div>

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          BIOCHEMISTRY + SEROLOGY REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">BIOCHEMISTRY</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>Fasting Blood Sugar</td>
              <td>{form.fastingSugar} mg/dl</td>
              <td>70 to 110 mg/dl</td>
            </tr>
            <tr>
              <td>Post Meal Blood Sugar</td>
              <td>{form.postMealSugar} mg/dl</td>
              <td>80 to 140 mg/dl</td>
            </tr>
            <tr>
              <td>Random Blood Sugar</td>
              <td>{form.randomSugar} mg/dl</td>
              <td>80 to 140 mg/dl</td>
            </tr>
            <tr>
              <td>SGPT (ALT)</td>
              <td>{form.sgpt} u/l</td>
              <td>00 to 40 u/l</td>
            </tr>
            <tr>
              <td>SGOT (AST)</td>
              <td>{form.sgot} u/l</td>
              <td>00 to 40 u/l</td>
            </tr>
          </tbody>
        </table>

        <h5 className="text-decoration-underline">SEROLOGY - CHIKUNGUNYA</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>IgG</td>
              <td>{form.chikIgG}</td>
            </tr>
            <tr>
              <td>IgM</td>
              <td>{form.chikIgM}</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default SugarSgptForm;
